import isBefore from 'date-fns/is_before';

/**
 * Checks if a ticket is still eligible for name changes based on the event end date
 * @param {String} endDate - The ticket's event end date
 * @returns {Boolean} - True if name changes are allowed, false otherwise
 */
export const isTicketNameChangeAllowed = endDate => {
  if (!endDate) {
    // If no end date, assume it's not valid
    return false;
  }

  try {
    const currentDate = new Date();
    const eventEndDate = new Date(endDate);

    // Check if the date is valid
    if (isNaN(eventEndDate.getTime())) {
      return false;
    }

    // Allow name changes only if the current date is before the event end date
    return isBefore(currentDate, eventEndDate);
  } catch (error) {
    throw new Error('Incorrect date on ticketedEvent', error);
  }
};
